import React from 'react'
import SbEditable from 'storyblok-react'
import Heading from "src/components/Heading"
import Button from "src/components/Button"
import RichText from "src/utils/RichText"
import Wave from "src/utils/Wave"
import ConnectCharacter from 'src/images/connect_character.svg'
import ProtectCharacter from 'src/images/protect_character.svg'
import InspectCharacter from 'src/images/inspect_character.svg'

const SimpleCenteredBranded = ({ blok }) => {
    const topWave = ['both', 'top'].includes(blok.wave_position) ? true : false
    const bottomWave = ['both', 'bottom'].includes(blok.wave_position) ? true : false
    const bottomPadding = (blok.wave_position === 'top' || !blok.wave_position) ? true : false
    const topPadding = (blok.wave_position === 'bottom' || !blok.wave_position) ? true : false
    const characterClasses = `md:max-w-full max-w-[90%] mb-8 mx-auto bottom-full absolute left-1/2 -translate-x-1/2`
    const character = 
        blok.character === 'connect' ? <ConnectCharacter className={characterClasses}/>
        : blok.character === 'protect' ? <ProtectCharacter className={`${characterClasses} md:!mb-8 !mb-0`}/>
        : blok.character === 'inspect' ? <InspectCharacter className={characterClasses}/>
        : ''
    const characterFillerClasses = 'opacity-0 -mb-[5%]'
    const characterFiller = 
        blok.character === 'connect' ? <ConnectCharacter className={characterFillerClasses}/>
        : blok.character === 'protect' ? <ProtectCharacter className={characterFillerClasses}/>
        : blok.character === 'inspect' ? <InspectCharacter className={characterFillerClasses}/>
        : ''
    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="relative overflow-hidden">
                {characterFiller}
                {topWave && <Wave className={`${blok.teal_background ? "fill-teal" : "fill-brightgreen"}`} flip scale/>}
                <div className={`relative ${blok.teal_background ? "bg-teal" : "bg-brightgreen"}`}>
                    <div 
                        className={`max-w-7xl mx-auto px-6 py-12
                        ${bottomPadding && 'lg:pb-24'}
                        ${topPadding && 'lg:pt-24'}
                        `}
                    >
                        <div className="text-center max-w-lg mx-auto">
                            <div className="h-0 relative">
                            {character}
                            </div>
                            {blok.teal_background ?
                            <div className={`whiteBoldNormal ${blok.teal_background ? "text-white font-display font-medium text-3xl tracking-[-1.5px] md:text-4xl lg:text-5xl" : "text-darkblue"}`}>
                                <RichText>{blok.title}</RichText>
                            </div>:
                                <div className={'font-display font-medium text-3xl tracking-[-1.5px] md:text-4xl lg:text-5xl'}>
                                <RichText className={`whiteBoldNormal ${blok.teal_background ? "text-white" : "text-darkblue"}`}>{blok.title}</RichText>
                                </div>
                            }
                            <div className={`mt-6 prose ${blok.teal_background ? "text-white" : "text-darkblue"}`}>
                                <RichText>{blok.content}</RichText>
                            </div>
                            <Button
                                to={blok.button_target?.cached_url}
                                target={blok.button_target?.linktype !== 'story' ? '_blank' : ''}
                                before={blok.button_text}
                                className={`bg-darkblue hover:bg-darkbluehover mt-8 before:content-[attr(before)]`}
                            >
                                {blok.button_text}
                            </Button>
                        </div>
                    </div>
                </div>
                {bottomWave && <Wave className={`${blok.teal_background ? "fill-teal" : "fill-brightgreen"}`} scale/>}
            </div>      
        </SbEditable>
    )
}

export default SimpleCenteredBranded